import strings from '@/helpers/strings'

export default {

    computed: {
        /**
         * @returns {Resources | {}}
         */
        allResources() {
            return this.scheme.resources
        },

        /**
         * @returns {CommonResources | {}}
         */
        commonResources() {
            return this.scheme.resources.common
        },

        /**
         * @returns {Scheme}
         */
        scheme() {
            return this.$scheme
        },
    },

    methods: {

        /**
         * @param {String} key The key for the resources to parse.
         * @returns {any} A dynamic object of resource data.
         * Parses the resources with the specified key.
         */
        parseResources(key) {
            return strings.parseObject(key, this.allResources)
        },
    },
}
